module.exports = __webpack_public_path__ + "img/duomai_logo_en.0f7e5375.png";